import { QueryParam } from "../../../types/api/generic.type";
import {
  GetNotificationsCounters,
  GetNotificationsResponse,
} from "../../../types/api/notifications.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const NotificationsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetNotificationsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetNotificationsResponse>(
      `v1/notifications?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async getCounters(): Promise<GetNotificationsCounters> {
    const response = await httpClient.get<GetNotificationsCounters>(
      "v1/notifications/counters",
    );
    return response;
  },
  async read(notificationId: number): Promise<void> {
    await httpClient.put(`v1/notifications/${notificationId}/read`);
  },
  async readAll(): Promise<void> {
    await httpClient.put("v1/notifications/read-all");
  },
};

export default NotificationsService;
